var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLast2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 297,
    viewBox: "0 0 299 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.658 295.582C143.447 293.04 132.535 282.804 122.913 273.773C117.76 268.939 112.887 264.368 107.68 261.089C95.9129 253.682 85.4204 250.868 75.27 248.148C58.8629 243.757 41.8962 239.21 23.6394 216.243C5.25822 193.113 -1.63569 171.095 2.56906 148.928C6.68831 127.19 21.3622 108.396 33.6811 94.461C41.7175 85.3597 47.3368 74.0979 53.2747 62.1753C58.4432 51.8073 63.7827 41.0894 71.0264 31.3665C89.6096 6.44109 107.703 -2.50469 131.525 1.47467C140.712 3.00578 150.155 6.30896 160.15 9.80644C168.987 12.892 178.119 16.0863 188.355 18.5968C189.342 18.8377 190.391 19.0553 191.464 19.2341C196.671 20.1046 202.158 20.1279 207.957 20.159C214.151 20.1901 220.547 20.2212 227.053 21.3093C234.84 22.6072 241.54 25.2575 247.517 29.4001C265.999 42.2009 267.693 56.8203 269.333 70.9501C270.002 76.7093 270.693 82.655 272.536 88.8339C274.89 96.7149 279.134 103.982 283.626 111.684C290.497 123.451 297.601 135.622 298.308 150.926C299.668 180.382 280.331 196.743 265.673 206.489C260.971 209.621 256.338 212.085 251.862 214.471C242.55 219.43 234.514 223.712 229.237 232.347C227.659 234.927 226.82 239.35 226.011 243.625C225.04 248.754 224.029 254.063 221.55 258.835C212.581 276.12 192.964 294.33 169.36 296.071C165.723 296.32 162.124 296.157 158.658 295.582Z",
    stroke: "url(#paint0_linear_72_288)",
    strokeMiterlimit: 10,
    strokeDasharray: "25 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.725 211.409C57.2774 246.073 79.5524 234.189 111.823 254.506C130.211 266.078 142.927 290.195 168.793 288.299C188.246 286.869 205.936 272.04 214.656 255.236C218.729 247.386 218.169 235.549 222.607 228.282C231.77 213.29 246.895 209.629 261.375 200.007C278.062 188.908 291.624 174.662 290.544 151.276C289.494 128.464 271.424 112.298 265.082 91.049C258.445 68.805 265.579 51.3642 243.087 35.7733C225.195 23.3766 205.096 30.698 186.498 26.1358C138.955 14.4853 112.981 -11.9246 77.2519 36.0064C62.306 56.0586 55.5519 81.4348 39.4946 99.5983C10.9552 131.907 -6.82751 165.421 29.725 211.409Z",
    fill: "url(#paint1_linear_72_288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.225 109.742H188.211V82.3121H195.066V106.14H203.459V82.3121H210.873V74H97.563V82.3121H120.225V109.742Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.742 126.673C128.742 140.819 140.171 152.329 154.218 152.329C168.265 152.329 179.694 140.819 179.694 126.673V118.107H128.742V126.673Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.717 153.85L154.218 198.944L120.719 153.85C104.799 157.919 93 172.327 93 189.426V216.969H215.436V189.426C215.436 172.327 203.637 157.919 187.717 153.85Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.173 152.329H176.568C170.586 157.605 162.766 160.806 154.218 160.806C145.67 160.806 137.849 157.605 131.868 152.329H130.263L154.218 185.029L178.173 152.329Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_288",
    x1: 68.5065,
    y1: 26.2325,
    x2: 235.03,
    y2: 259.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A99D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_288",
    x1: 74.0975,
    y1: 34.0686,
    x2: 231.551,
    y2: 254.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A99D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLast2);
export default __webpack_public_path__ + "static/media/Last2.6b5a007ed610388f64c4fe5f846a2ab9.svg";
export { ForwardRef as ReactComponent };